import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate, CanActivateChild, CanLoad,
  Route, Router, RouterStateSnapshot
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate, CanActivateChild, CanLoad {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url: string = state.url;

    return this.checkLogin(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route) {
    let url = `/${ route.path }`;

    return this.checkLogin(url);
  }

  private checkLogin(url: string): boolean {
    if(this.auth.authenticated()) {
      return true;
    }

    console.log('Not authenticated, navigating to login');
    //noinspection JSIgnoredPromiseFromCall
    this.router.navigate(['/login'], { queryParams: { redirectTo: url } });

    return false;
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/auth-guard.service.ts